/* ==========================================================================
   Feminine Flair Wardrobe - Custom Shopify Theme Scripts
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function() {
  initHeaderScroll();
  initMobileNav();
  initCartDrawer();
  initSearchOverlay();
  initWishlist();
  initWatchBuyVideos();
  
  // Template specific initializations
  if (document.querySelector('.product-template')) {
    initProductTemplate();
  }
  if (document.querySelector('.collection-page-layout')) {
    initCollectionPage();
  }
});

/* ==========================================================================
   1. Sticky Header Scroll Effect
   ========================================================================== */
function initHeaderScroll() {
  const header = document.querySelector('.site-header');
  if (!header) return;

  window.addEventListener('scroll', () => {
    if (window.scrollY > 50) {
      header.classList.add('site-header--compact');
    } else {
      header.classList.remove('site-header--compact');
    }
  });
}

/* ==========================================================================
   2. Mobile Navigation Drawer Toggling
   ========================================================================== */
function initMobileNav() {
  const toggleBtn = document.querySelector('.mobile-nav-toggle');
  const closeBtn = document.querySelector('.mobile-nav-drawer__close');
  const drawer = document.querySelector('.mobile-nav-drawer');
  const backdrop = document.querySelector('.drawer-backdrop');

  if (!drawer || !toggleBtn) return;

  function openDrawer() {
    drawer.classList.add('open');
    backdrop.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('open');
    if (!document.querySelector('.cart-drawer.open')) {
      backdrop.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  toggleBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  
  // Close when clicking backdrop
  backdrop.addEventListener('click', () => {
    closeDrawer();
  });
}

/* ==========================================================================
   3. AJAX Cart Drawer Engine
   ========================================================================== */
function initCartDrawer() {
  const cartTrigger = document.querySelector('.cart-trigger');
  const closeBtn = document.querySelector('.cart-drawer__close');
  const drawer = document.querySelector('.cart-drawer');
  const backdrop = document.querySelector('.drawer-backdrop');

  if (!drawer) return;

  function openDrawer() {
    drawer.classList.add('open');
    backdrop.classList.add('active');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  }

  function closeDrawer() {
    drawer.classList.remove('open');
    if (!document.querySelector('.mobile-nav-drawer.open')) {
      backdrop.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  if (cartTrigger) {
    cartTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      openDrawer();
    });
  }

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  
  backdrop.addEventListener('click', closeDrawer);

  // Expose global drawer trigger functions
  window.CartDrawer = {
    open: openDrawer,
    close: closeDrawer,
    refresh: refreshCartDrawer,
    addItem: function(variantId, qty = 1) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      })
      .catch(() => fetch('/api/cart/add', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      }))
      .then(res => res.json())
      .then(() => {
        refreshCartDrawer();
        openDrawer();
      })
      .catch(err => console.log('Add item error:', err));
    }
  };

  // Delegate quantity buttons and remove actions inside drawer
  drawer.addEventListener('click', (e) => {
    const target = e.target;
    
    if (target.classList.contains('qty-btn')) {
      const variantId = target.dataset.id;
      const currentVal = parseInt(target.parentElement.querySelector('.qty-val').innerText);
      const action = target.dataset.action;
      const newVal = action === 'plus' ? currentVal + 1 : currentVal - 1;
      
      changeCartQuantity(variantId, newVal);
    }
    
    if (target.classList.contains('cart-item__remove')) {
      e.preventDefault();
      const variantId = target.dataset.id;
      changeCartQuantity(variantId, 0);
    }
  });
}

function changeCartQuantity(variantId, qty) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty })
  })
  .catch(() => fetch('/api/cart/change', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: qty })
  }))
  .then(res => res.json())
  .then(() => {
    refreshCartDrawer();
  })
  .catch(err => console.log('Change quantity error:', err));
}

function updateCartBadges(count) {
  const badges = document.querySelectorAll('.cart-count-badge');
  badges.forEach(badge => {
    badge.innerText = count || 0;
    badge.style.display = (count && count > 0) ? 'flex' : 'none';
  });
}

function refreshCartDrawer() {
  fetch('/cart.js')
    .catch(() => fetch('/api/cart'))
    .then(res => res.json())
    .then(cart => {
      if (cart) {
        updateCartBadges(cart.item_count);
        renderCartDrawerItems(cart);
      }
    })
    .catch(err => console.log('Refresh cart notice:', err));
}

function renderCartDrawerItems(cart) {
  const itemsContainer = document.querySelector('.cart-drawer__items');
  const footerContainer = document.querySelector('.cart-drawer__footer');
  const shippingThresholdText = document.querySelector('.shipping-bar__text');
  const shippingFill = document.querySelector('.shipping-bar__fill');
  
  if (!itemsContainer) return;

  // Free shipping threshold calculations (dynamic via settings data-threshold)
  const drawerEl = document.getElementById('CartDrawer');
  const thresholdVal = drawerEl ? parseInt(drawerEl.getAttribute('data-threshold')) || 999 : 999;
  const threshold = thresholdVal * 100; // convert to cents/paise
  
  if (cart.total_price >= threshold) {
    if (shippingThresholdText) shippingThresholdText.innerText = "Yay! You qualify for FREE SHIPPING!";
    if (shippingFill) shippingFill.style.width = '100%';
  } else {
    const diff = threshold - cart.total_price;
    const diffFormatted = '₹' + (diff / 100).toLocaleString('en-IN');
    if (shippingThresholdText) shippingThresholdText.innerText = `Add ${diffFormatted} more to unlock FREE SHIPPING.`;
    const percentage = (cart.total_price / threshold) * 100;
    if (shippingFill) shippingFill.style.width = `${percentage}%`;
  }

  if (cart.items.length === 0) {
    itemsContainer.innerHTML = `
      <div class="cart-drawer__empty-message">
        <h3 style="font-family: var(--font-heading); font-size: 1.4rem; margin-bottom: 8px; font-weight: 500;">YOUR CART IS EMPTY</h3>
        <a href="/collections/all" class="btn btn-secondary" style="margin-top: 15px; border-radius: 0; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: 1px;">CONTINUE SHOPPING</a>
      </div>
    `;
    if (footerContainer) footerContainer.style.display = 'none';
    return;
  }

  if (footerContainer) footerContainer.style.display = 'block';

  // Render items list
  itemsContainer.innerHTML = cart.items.map(item => {
    const formattedPrice = '₹' + (item.price / 100 * item.quantity).toLocaleString('en-IN');
    return `
      <div class="cart-item">
        <div class="cart-item__image-container">
          <img src="${item.image}" alt="${item.product_title}" class="cart-item__image">
        </div>
        <div class="cart-item__details">
          <div class="cart-item__title">${item.product_title}</div>
          <div class="cart-item__options">${item.variant_title}</div>
          <div class="cart-item__qty-price">
            <div class="qty-selector">
              <button class="qty-btn" data-action="minus" data-id="${item.variant_id}">-</button>
              <div class="qty-val">${item.quantity}</div>
              <button class="qty-btn" data-action="plus" data-id="${item.variant_id}">+</button>
            </div>
            <div class="cart-item__price">${formattedPrice}</div>
          </div>
          <a href="#" class="cart-item__remove" data-id="${item.variant_id}">Remove</a>
        </div>
      </div>
    `;
  }).join('');

  // Update footer subtotal
  const subtotalVal = document.querySelector('.cart-drawer__subtotal-value');
  if (subtotalVal) {
    subtotalVal.innerText = '₹' + (cart.total_price / 100).toLocaleString('en-IN');
  }
}

/* ==========================================================================
   4. Search Overlay & Predictive Search Engine
   ========================================================================== */
function initSearchOverlay() {
  const searchTrigger = document.querySelector('.search-trigger');
  const closeBtn = document.querySelector('.search-overlay__close');
  const overlay = document.querySelector('.search-overlay');
  const searchInput = document.querySelector('.search-bar__input');
  const suggestions = document.querySelector('.predictive-results');

  if (!overlay || !searchTrigger) return;

  function openSearch() {
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    setTimeout(() => searchInput.focus(), 300);
  }

  function closeSearch() {
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  searchTrigger.addEventListener('click', (e) => {
    e.preventDefault();
    openSearch();
  });

  if (closeBtn) closeBtn.addEventListener('click', closeSearch);

  // Predictive search typing with debounce
  let debounceTimeout;
  searchInput.addEventListener('input', () => {
    clearTimeout(debounceTimeout);
    const query = searchInput.value.trim();
    
    if (query.length < 2) {
      if (suggestions) suggestions.innerHTML = '';
      return;
    }

    debounceTimeout = setTimeout(() => {
      fetch(`/api/search?q=${encodeURIComponent(query)}`)
        .then(res => res.json())
        .then(data => {
          renderSearchResults(data.resources.results.products);
        });
    }, 250);
  });
}

function renderSearchResults(products) {
  const container = document.querySelector('.predictive-results');
  if (!container) return;

  if (products.length === 0) {
    container.innerHTML = `
      <div style="grid-column: 1 / -1; text-align: center; padding: 20px 0; color: #666; width: 100%;">
        <h4 style="font-family: var(--font-heading); font-size: 1.2rem; margin-bottom: 8px; font-weight: 500; text-transform: uppercase;">NO RESULTS FOUND</h4>
        <a href="/collections/all" class="btn btn-secondary" style="border-radius: 0; font-size: 10px; font-weight: 600; text-transform: uppercase; letter-spacing: 0.5px; padding: 8px 16px;">CONTINUE SHOPPING</a>
      </div>
    `;
    return;
  }

  container.innerHTML = products.map(p => {
    const formattedPrice = '₹' + (p.price / 100).toLocaleString('en-IN');
    const comparePriceText = p.compare_at_price ? `<span style="font-size: 11px; text-decoration: line-through; color: #888;">₹${(p.compare_at_price / 100).toLocaleString('en-IN')}</span>` : '';
    return `
      <div class="predictive-item">
        <a href="${p.url}" style="aspect-ratio: 3/4; overflow: hidden; display: block; border: 1px solid var(--color-border-neutral); margin-bottom: 8px;">
          <img src="${p.featured_image.url}" alt="${p.title}" style="width:100%; height:100%; object-fit:cover;">
        </a>
        <a href="${p.url}" style="font-size: 13px; font-weight: 500; text-overflow: ellipsis; overflow: hidden; white-space: nowrap; margin-bottom: 4px;">${p.title}</a>
        <div style="font-size:12px; font-weight:700; display:flex; gap: 6px; align-items:center;">
          <span>${formattedPrice}</span>
          ${comparePriceText}
        </div>
      </div>
    `;
  }).join('');
}

/* ==========================================================================
   5. LocalStorage Wishlist Implementation
   ========================================================================== */
function initWishlist() {
  let wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];

  function updateWishlistButtons() {
    const buttons = document.querySelectorAll('.product-card__wishlist');
    buttons.forEach(btn => {
      const productId = parseInt(btn.dataset.id);
      if (wishlist.includes(productId)) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
  }

  document.body.addEventListener('click', (e) => {
    const target = e.target.closest('.product-card__wishlist');
    if (!target) return;
    
    e.preventDefault();
    const productId = parseInt(target.dataset.id);
    const index = wishlist.indexOf(productId);
    
    if (index > -1) {
      wishlist.splice(index, 1);
      target.classList.remove('active');
    } else {
      wishlist.push(productId);
      target.classList.add('active');
    }
    
    localStorage.setItem('wishlist', JSON.stringify(wishlist));
    updateWishlistButtons();
  });

  updateWishlistButtons();
}

/* ==========================================================================
   6. Product Page Template Operations (Gallery / Accordions / Variants)
   ========================================================================== */
function initProductTemplate() {
  const container = document.querySelector('.product-template');
  if (!container) return;

  // 1. Gallery Swap
  const thumbs = container.querySelectorAll('.gallery-thumb');
  const mainImage = container.querySelector('.product-gallery__main img');
  
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImage) mainImage.src = thumb.dataset.src;
    });
  });

  // Mobile Touch Swipe for Main Image
  if (mainImage && thumbs.length > 0) {
    let touchStartX = 0;
    let touchEndX = 0;
    
    mainImage.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });
    
    mainImage.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleGallerySwipe();
    }, { passive: true });
    
    function handleGallerySwipe() {
      const threshold = 50;
      const activeThumb = container.querySelector('.gallery-thumb.active');
      if (!activeThumb) return;
      
      let activeIndex = Array.from(thumbs).indexOf(activeThumb);
      
      if (touchStartX - touchEndX > threshold) {
        // Swiped Left -> Next image
        if (activeIndex < thumbs.length - 1) {
          thumbs[activeIndex + 1].click();
        }
      } else if (touchEndX - touchStartX > threshold) {
        // Swiped Right -> Previous image
        if (activeIndex > 0) {
          thumbs[activeIndex - 1].click();
        }
      }
    }
  }

  // 2. Dynamic Variant Options Selection
  const variantIdInput = container.querySelector('input[name="id"]');
  const addToCartBtn = container.querySelector('.btn-add-to-cart');
  const priceDisplay = container.querySelector('.product-price-actual');
  const compareDisplay = container.querySelector('.product-price-compare');
  const discountDisplay = container.querySelector('.product-price-discount');

  // Load product data from inline script variable
  const productData = JSON.parse(document.getElementById('ProductJsonData').innerText);

  function getSelectedOptions() {
    const selected = {};
    const pillContainers = container.querySelectorAll('.selector-pills');
    pillContainers.forEach(containerEl => {
      const optionIndex = containerEl.dataset.optionIndex; // e.g. "option1", "option2"
      const activePill = containerEl.querySelector('.pill-option.active, .color-option.active');
      if (activePill) {
        selected[optionIndex] = activePill.dataset.value;
      }
    });
    return selected;
  }

  function updateOptionAvailability() {
    const selected = getSelectedOptions();
    const pillContainers = container.querySelectorAll('.selector-pills');
    
    pillContainers.forEach(containerEl => {
      const currentOptionIndex = containerEl.dataset.optionIndex;
      const pills = containerEl.querySelectorAll('.pill-option, .color-option');
      
      pills.forEach(pill => {
        const pillValue = pill.dataset.value;
        // Build a hypothetical selection if this pill was selected
        const hypotheticalSelected = { ...selected, [currentOptionIndex]: pillValue };
        
        // Find if there is any available variant matching this hypothetical selection
        // Note: we only match against the OTHER options that are already selected
        const isAvailable = productData.variants.some(variant => {
          if (!variant.available) return false;
          return Object.keys(hypotheticalSelected).every(key => {
            return variant[key] === hypotheticalSelected[key];
          });
        });
        
        if (!isAvailable) {
          pill.classList.add('disabled');
          pill.style.opacity = '0.3';
          if (pill.classList.contains('pill-option')) {
            pill.style.textDecoration = 'line-through';
          }
        } else {
          pill.classList.remove('disabled');
          pill.style.opacity = '';
          pill.style.textDecoration = '';
        }
      });
    });
  }

  function updateActiveVariant() {
    const selected = getSelectedOptions();
    let matchedVariant = null;
    
    // Find variant that matches all selected options
    matchedVariant = productData.variants.find(variant => {
      return Object.keys(selected).every(key => {
        return variant[key] === selected[key];
      });
    });

    if (matchedVariant) {
      variantIdInput.value = matchedVariant.id;
      
      // Update price display
      const formattedPrice = '₹' + (matchedVariant.price / 100).toLocaleString('en-IN');
      if (priceDisplay) priceDisplay.innerText = formattedPrice;
      
      // Also update sticky mobile bar price if visible
      const stickyPrice = document.querySelector('.sticky-mobile-bar__price .product-price-actual');
      if (stickyPrice) stickyPrice.innerText = formattedPrice;

      if (matchedVariant.compare_at_price) {
        if (compareDisplay) {
          compareDisplay.innerText = '₹' + (matchedVariant.compare_at_price / 100).toLocaleString('en-IN');
          compareDisplay.style.display = 'block';
        }
        if (discountDisplay) {
          const discount = Math.round(((matchedVariant.compare_at_price - matchedVariant.price) / matchedVariant.compare_at_price) * 100);
          discountDisplay.innerText = `Save ${discount}%`;
          discountDisplay.style.display = 'inline-block';
        }
      } else {
        if (compareDisplay) compareDisplay.style.display = 'none';
        if (discountDisplay) discountDisplay.style.display = 'none';
      }

      // Update button status
      const stickyBtn = document.querySelector('.sticky-mobile-bar__btn');
      if (matchedVariant.available) {
        if (addToCartBtn) {
          addToCartBtn.removeAttribute('disabled');
          addToCartBtn.innerText = "Add to Cart";
        }
        if (stickyBtn) {
          stickyBtn.removeAttribute('disabled');
          stickyBtn.innerText = "Add to Cart";
        }
      } else {
        if (addToCartBtn) {
          addToCartBtn.setAttribute('disabled', 'disabled');
          addToCartBtn.innerText = "Sold Out";
        }
        if (stickyBtn) {
          stickyBtn.setAttribute('disabled', 'disabled');
          stickyBtn.innerText = "Sold Out";
        }
      }
    }
    
    updateOptionAvailability();
  }

  // Bind click events dynamically to all pills
  const allOptionPills = container.querySelectorAll('.selector-pills .pill-option, .selector-pills .color-option');
  allOptionPills.forEach(pill => {
    pill.addEventListener('click', () => {
      const pillContainer = pill.closest('.selector-pills');
      pillContainer.querySelectorAll('.pill-option, .color-option').forEach(p => p.classList.remove('active'));
      pill.classList.add('active');
      updateActiveVariant();
    });
  });

  // Initialize option mapping
  updateOptionAvailability();


  // 3. Size Guide Modal
  const sizeGuideBtn = container.querySelector('.size-guide-btn');
  const sizeGuideModal = document.querySelector('.modal-overlay');
  const sizeGuideClose = document.querySelector('.modal-close');

  if (sizeGuideBtn && sizeGuideModal) {
    sizeGuideBtn.addEventListener('click', () => sizeGuideModal.classList.add('open'));
    if (sizeGuideClose) sizeGuideClose.addEventListener('click', () => sizeGuideModal.classList.remove('open'));
    sizeGuideModal.addEventListener('click', (e) => {
      if (e.target === sizeGuideModal) sizeGuideModal.classList.remove('open');
    });
  }

  // 4. Accordion Toggle
  const accordions = container.querySelectorAll('.accordion-item');
  accordions.forEach(item => {
    const title = item.querySelector('.accordion-title');
    title.addEventListener('click', () => {
      const isActive = item.classList.contains('active');
      accordions.forEach(acc => acc.classList.remove('active'));
      if (!isActive) item.classList.add('active');
    });
  });

  // 5. Add to Cart Submission Handler
  const mainProductForm = container.querySelector('.main-product-form');
  if (mainProductForm) {
    mainProductForm.addEventListener('submit', (e) => {
      e.preventDefault();
      const variantId = variantIdInput.value;
      const qtyInput = mainProductForm.querySelector('.qty-input');
      const qtyVal = parseInt(qtyInput ? qtyInput.value : "1") || 1;
      
      const originalText = addToCartBtn.innerText;
      addToCartBtn.setAttribute('disabled', 'disabled');
      addToCartBtn.innerHTML = '<span class="loading-spinner" style="display:inline-block; width:12px; height:12px; border:2px solid rgba(255,255,255,0.3); border-radius:50%; border-top-color:#fff; animation:spin 1s ease-in-out infinite; margin-right:8px; vertical-align: middle;"></span>Adding...';
      
      window.CartDrawer.addItem(variantId, qtyVal)
        .then(() => {
          addToCartBtn.innerHTML = '✓ Added!';
          addToCartBtn.style.backgroundColor = '#2D5A27';
          addToCartBtn.style.borderColor = '#2D5A27';
          
          setTimeout(() => {
            addToCartBtn.removeAttribute('disabled');
            addToCartBtn.innerText = originalText;
            addToCartBtn.style.backgroundColor = '';
            addToCartBtn.style.borderColor = '';
          }, 2000);
        })
        .catch(err => {
          console.error(err);
          addToCartBtn.removeAttribute('disabled');
          addToCartBtn.innerText = originalText;
        });
    });

    // Add to Cart page quantity selector
    const qtyMin = mainProductForm.querySelector('.qty-btn[data-action="minus"]');
    const qtyPlu = mainProductForm.querySelector('.qty-btn[data-action="plus"]');
    const qtyInput = mainProductForm.querySelector('.qty-input');

    if (qtyMin && qtyPlu && qtyInput) {
      qtyMin.addEventListener('click', () => {
        let val = parseInt(qtyInput.value) || 1;
        if (val > 1) qtyInput.value = val - 1;
      });
      qtyPlu.addEventListener('click', () => {
        let val = parseInt(qtyInput.value) || 1;
        qtyInput.value = val + 1;
      });
    }

    // Secure Accelerated Checkout (Buy It Now) Click Handler
    const buyNowBtn = container.querySelector('.buy-now-btn');
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', (e) => {
        e.preventDefault();
        const variantId = variantIdInput.value;
        const qtyInput = mainProductForm.querySelector('.qty-input');
        const qtyVal = parseInt(qtyInput ? qtyInput.value : "1") || 1;
        
        const originalText = buyNowBtn.innerText;
        buyNowBtn.setAttribute('disabled', 'disabled');
        buyNowBtn.innerText = 'Redirecting...';
        
        fetch('/api/cart/add', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qtyVal })
        })
        .then(res => res.json())
        .then(() => {
          window.location.href = '/checkout';
        })
        .catch(err => {
          console.error(err);
          buyNowBtn.removeAttribute('disabled');
          buyNowBtn.innerText = originalText;
        });
      });
    }
  }

  // 6. Sticky Mobile Purchase Bar
  const stickyBar = document.querySelector('.sticky-mobile-bar');
  if (stickyBar) {
    const mainBtn = container.querySelector('.btn-add-to-cart');
    const stickyBtn = stickyBar.querySelector('.sticky-mobile-bar__btn');
    
    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        if (mainProductForm) {
          // Trigger main form submit handler
          const submitEvent = new Event('submit', { cancelable: true, bubbles: true });
          mainProductForm.dispatchEvent(submitEvent);
        }
      });
    }

    window.addEventListener('scroll', () => {
      if (window.innerWidth <= 768 && mainBtn) {
        const btnPosition = mainBtn.getBoundingClientRect().bottom;
        if (btnPosition < 0) {
          stickyBar.style.display = 'flex';
        } else {
          stickyBar.style.display = 'none';
        }
      } else {
        stickyBar.style.display = 'none';
      }
    }, { passive: true });
  }
}

/* ==========================================================================
   7. Collection Filtering & Sorting Engine (AJAX Section Rendering Simulation)
   ========================================================================== */
function initCollectionPage() {
  const filters = document.querySelectorAll('.filter-checkbox');
  const sort = document.querySelector('.sort-selector');
  const filterBtn = document.querySelector('.mobile-filter-btns .btn-filter');
  const sortBtn = document.querySelector('.mobile-filter-btns .btn-sort');
  const sidebar = document.querySelector('.collection-sidebar');

  // Toggle sidebar on mobile
  if (filterBtn && sidebar) {
    filterBtn.addEventListener('click', () => {
      sidebar.classList.toggle('open');
    });
  }

  // When sorting or filtering updates, trigger collection query updates
  filters.forEach(filter => {
    filter.addEventListener('change', reloadCollectionGrid);
  });

  if (sort) {
    sort.addEventListener('change', reloadCollectionGrid);
  }

  function reloadCollectionGrid() {
    const currentUrl = new URL(window.location.href);
    const selectedSizes = Array.from(document.querySelectorAll('.filter-checkbox[data-type="size"]:checked')).map(cb => cb.value);
    const selectedColors = Array.from(document.querySelectorAll('.filter-checkbox[data-type="color"]:checked')).map(cb => cb.value);
    const selectedPrices = Array.from(document.querySelectorAll('.filter-checkbox[data-type="price"]:checked')).map(cb => cb.value);
    const sortBy = sort ? sort.value : '';

    // Simulate Shopify URL updates
    currentUrl.searchParams.delete('size');
    currentUrl.searchParams.delete('color');
    currentUrl.searchParams.delete('price');
    currentUrl.searchParams.delete('sort_by');

    if (selectedSizes.length) currentUrl.searchParams.set('size', selectedSizes.join(','));
    if (selectedColors.length) currentUrl.searchParams.set('color', selectedColors.join(','));
    if (selectedPrices.length) currentUrl.searchParams.set('price', selectedPrices.join(','));
    if (sortBy) currentUrl.searchParams.set('sort_by', sortBy);

    // Update address bar
    window.history.pushState({ path: currentUrl.href }, '', currentUrl.href);

    // Perform simulated grid update by doing a fetch request to current URL
    // and reloading the grid content dynamically (Shopify Online Store 2.0 AJAX behavior)
    const productGridContainer = document.querySelector('.collection-content');
    if (!productGridContainer) return;
    
    // Add loading opacity
    productGridContainer.style.opacity = '0.5';

    fetch(currentUrl.href)
      .then(res => res.text())
      .then(htmlString => {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = htmlString;
        
        // Find the newly rendered collection-content
        const newContent = tempDiv.querySelector('.collection-content');
        if (newContent) {
          productGridContainer.innerHTML = newContent.innerHTML;
        }
        productGridContainer.style.opacity = '1';
        
        // Reinitialize cards (since cards might have new wishlist buttons)
        initWishlist();
      })
      .catch(err => {
        console.error("AJAX reload error:", err);
        productGridContainer.style.opacity = '1';
      });
  }
}

/* ==========================================================================
   Watch & Buy Videos Section Controller
   ========================================================================== */
function initWatchBuyVideos() {
  const sections = document.querySelectorAll('.watch-buy-videos-section');
  if (!sections.length) return;

  sections.forEach(section => {
    const isAutoplay = section.getAttribute('data-autoplay') === 'true';
    const cards = section.querySelectorAll('.watch-buy-card');

    cards.forEach(card => {
      const video = card.querySelector('.watch-buy-card__video');
      const playBtn = card.querySelector('.watch-buy-card__play-btn');
      const playIcon = playBtn ? playBtn.querySelector('.watch-buy-card__play-icon') : null;
      const pauseIcon = playBtn ? playBtn.querySelector('.watch-buy-card__pause-icon') : null;
      const playLabel = playBtn ? playBtn.getAttribute('data-play-label') : '';
      const pauseLabel = playBtn ? playBtn.getAttribute('data-pause-label') : '';

      if (!video) return;

      function updateCardState(playing) {
        if (playing) {
          card.classList.add('watch-buy-card--playing');
          if (playIcon) playIcon.style.display = 'none';
          if (pauseIcon) pauseIcon.style.display = 'flex';
          if (playBtn && pauseLabel) playBtn.setAttribute('aria-label', pauseLabel);
        } else {
          card.classList.remove('watch-buy-card--playing');
          if (playIcon) playIcon.style.display = 'flex';
          if (pauseIcon) pauseIcon.style.display = 'none';
          if (playBtn && playLabel) playBtn.setAttribute('aria-label', playLabel);
        }
      }

      function pauseOtherVideos() {
        document.querySelectorAll('.watch-buy-card__video').forEach(otherVideo => {
          if (otherVideo !== video && !otherVideo.paused) {
            otherVideo.pause();
            const otherCard = otherVideo.closest('.watch-buy-card');
            if (otherCard) {
              otherCard.classList.remove('watch-buy-card--playing');
              const oBtn = otherCard.querySelector('.watch-buy-card__play-btn');
              const oPlayIcon = oBtn ? oBtn.querySelector('.watch-buy-card__play-icon') : null;
              const oPauseIcon = oBtn ? oBtn.querySelector('.watch-buy-card__pause-icon') : null;
              const oPlayLabel = oBtn ? oBtn.getAttribute('data-play-label') : '';
              if (oPlayIcon) oPlayIcon.style.display = 'flex';
              if (oPauseIcon) oPauseIcon.style.display = 'none';
              if (oBtn && oPlayLabel) oBtn.setAttribute('aria-label', oPlayLabel);
            }
          }
        });
      }

      function togglePlayPause(e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }

        if (video.paused) {
          pauseOtherVideos();
          const playPromise = video.play();
          if (playPromise !== undefined) {
            playPromise
              .then(() => {
                updateCardState(true);
              })
              .catch(err => {
                console.warn('Video play interrupted or disallowed:', err);
                updateCardState(false);
              });
          }
        } else {
          video.pause();
          updateCardState(false);
        }
      }

      card.addEventListener('click', togglePlayPause);
      video.addEventListener('play', () => updateCardState(true));
      video.addEventListener('pause', () => updateCardState(false));
      video.addEventListener('ended', () => updateCardState(false));
    });

    if (isAutoplay && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          const video = entry.target.querySelector('.watch-buy-card__video');
          if (!video) return;
          if (entry.isIntersecting) {
            const playPromise = video.play();
            if (playPromise !== undefined) playPromise.catch(() => {});
          } else {
            video.pause();
          }
        });
      }, { threshold: 0.6 });

      cards.forEach(card => observer.observe(card));
    }
  });
}

document.addEventListener('shopify:section:load', function(e) {
  if (e.target && e.target.querySelector && e.target.querySelector('.watch-buy-videos-section')) {
    initWatchBuyVideos();
  }
});
```javascript
window.ffwShareProduct = async function (button) {
  const title = button.dataset.title;
  const url = button.dataset.url;
  const message = button.closest('.ffw-share')
    .querySelector('.ffw-share__message');

  try {
    if (navigator.share) {
      await navigator.share({ title, url });
    } else {
      await navigator.clipboard.writeText(url);
      message.textContent = 'Product link copied!';
    }
  } catch (error) {
    if (error.name !== 'AbortError') {
      message.textContent = 'Unable to share. Please copy the link.';
    }
  }
};

window.ffwCopyLink = async function (button) {
  const url = button.dataset.url;
  const message = button.closest('.ffw-share')
    .querySelector('.ffw-share__message');

  try {
    await navigator.clipboard.writeText(url);
    message.textContent = 'Link copied successfully!';
  } catch (error) {
    message.textContent = 'Copy failed. Please copy the URL manually.';
  }
};
```